import clsx from 'clsx'
import { FieldRenderProps } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

type NumberTextboxProps = FieldRenderProps<any, HTMLElement> & {
    label: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
    inputType?: 'number'
}

export const ViewNumberTextboxProps = () => (
    <pre className="prettyprint lang-js" style={{ backgroundColor: '#e6e6e6' }}>
        {`type NumberTextboxProps = {
    label: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
}`}
    </pre>
)

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        '& .MuiFormLabel-root': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '-webkit-fill-available',
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
        },
    },
    disabledField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.getContrastText('bg-backoffice'),
        },
    },
}))

const NumberTextboxControl = (props: NumberTextboxProps) => {
    const { t } = useTranslation()
    const classes = useStyles()
    const isError: boolean = props.meta.error && props.meta.touched
    const helperText: string = props.meta.error

    return (
        <>
            <Typography>
                {props.label} {!props.disabled && props.required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
            </Typography>
            <TextField
                variant="outlined"
                className={clsx(classes.label, { [classes.disabledField]: props.disabled })}
                value={props.input?.value ?? ''}
                placeholder={props.placeholder}
                onFocus={props.input.onFocus}
                onBlur={props.input.onBlur}
                onChange={props.input.onChange}
                error={isError}
                helperText={isError ? (helperText === 'Required' ? t('LABEL.TEXT_REQUIRED') : helperText) : ''}
                disabled={props.disabled}
                inputProps={{
                    type: props.inputType,
                    min: props.min,
                    max: props.max,
                    step: props.step ? props.step : 1,
                    maxLength: props.maxLength,
                    autoComplete: 'off',
                }}
                size="small"
                fullWidth={props.fullWidth}
            />
        </>
    )
}

export default NumberTextboxControl
